import { EPaymentCreationType, schemes, zSchema } from "@zeal/common";
import { createTransactionResponseSchema } from "../../../OdoClient/schemas";

export const createCompanyTransactionRequestSchema = zSchema.object({
  amount: zSchema.number().min(0, {
    message: "Amount must be a positive number",
  }),
  companyID: schemes.companyID(),
  type: zSchema.nativeEnum(EPaymentCreationType),
});

export type TCreateCompanyTransactionRequestSchema = zSchema.infer<
  typeof createCompanyTransactionRequestSchema
>;

export const createCompanyTransactionResponseSchema =
  createTransactionResponseSchema;

export type TCreateCompanyTransactionResponseSchema = zSchema.infer<
  typeof createCompanyTransactionResponseSchema
>;
